export default __webpack_public_path__ + "static/media/shockstrike.5c2fb21b.png";